import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "form-control-select" }
const _hoisted_4 = ["name", "id"]
const _hoisted_5 = ["value"]

import { PropType } from "vue";
import { IUmbracoFormField } from "@/models/umbraco-forms/IUmbracoFormField";
import IconChevronDown from "@/components/icons/IconChevronDown.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UmbracoFormDropdown',
  props: {
  field: {
    type: Object as PropType<IUmbracoFormField>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: __props.field.id,
      class: "umbraco-forms-label"
    }, _toDisplayString(__props.field.caption), 9, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("select", {
        class: "form-control",
        name: __props.field.alias,
        id: __props.field.id
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.field.preValues, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.value,
            key: option.caption
          }, _toDisplayString(option.caption), 9, _hoisted_5))
        }), 128))
      ], 8, _hoisted_4),
      _createVNode(IconChevronDown)
    ])
  ]))
}
}

})